<select class="form-select"
        [formControl]="selectRoom">
  @for (r of rooms(); track r) {
    <option [ngValue]="r"
            [selected]="r.id === room?.id">{{ r.displayName }}</option>
  }
</select>